(function(){

  const anchorClickHandler = (event, modal) => {
    event.preventDefault();
    event.stopPropagation();

    modal.toggle();

    return false;
  };

  const modalClickHandler = (event, modal) => {
    if (event.target == modal) {
      event.preventDefault();
      event.stopPropagation();
      
      modal.dismiss();
    }
  };

  const anchorClickSelector = (modalSelector) => `a[href="${ modalSelector }"]`;

  class DeallocModal extends HTMLElement {
    _abortController;

    constructor() {
      super();

      this._abortController = new AbortController();
    }

    connectedCallback() {
      this._bindElementEvents();
      this._bindAnchorEvents();
      this.style.display = null;
    }

    disconnectedCallback() {
      this._abortController.abort();
    }

    _bindElementEvents() {
      const { signal } = this._abortController;
      this.addEventListener('click', event => modalClickHandler(event, this), { signal })
    }

    _bindAnchorEvents() {
      const anchorSelector = anchorClickSelector(this.selector);
      const { signal } = this._abortController;

      document.querySelectorAll(anchorSelector).forEach(anchor => {
        anchor.addEventListener('click', event => anchorClickHandler(event, this), { signal });
      });
    }

    toggle() {
      this.classList.toggle('show');
    }

    dismiss() {
      this.classList.remove('show');
    }

    get selector() {
      return `#${ this.getAttribute('id') }`;
    }
 
  }

  window.customElements.define('dealloc-modal', DeallocModal);

})();